<!-- Check if data is busy loading -->
@if (isBusy()) {
  <!-- Show a loader while the data is being fetched -->
  <gate-loader [message]="'versionLog.loading' | translate"></gate-loader>
}

@if (!isBusy()) {
  @if (versionLogs().length > 0) {
    <div class="card">
      @for (versionLog of versionLogs(); track versionLog) {
        <h2 class=" md:text-xl text-md font-bold mb-4">V&nbsp;{{(versionLog.version?.major??0) + '.' + (versionLog.version?.minor??0) + (versionLog.version?.patch?'.' +versionLog.version?.patch:'')}}&nbsp;&nbsp;{{versionLog.title}}</h2>
        <div class="border-l-2 border-red-500 pl-4 mb-6 verison">
          <p class="md:text-base text-sm text-gray-500 font-semibold">{{versionLog.releaseDate | date: 'dd MMM, YYYY'}}</p>
          <div class="p-3 md:text-base text-sm overflow-auto" [innerHTML]="versionLog.description">
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="card">
      <p class="text-center text-gray-500">{{'versionLog.noVersionLogs' | translate}}</p>
    </div>
  }
}
